import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OrganizationForm from "../_components/OrganizationForm";
import apiService from "../../../../services/api";
import { setupAutoLogout } from "../../../../utils/auth";
import styles from "../Notice.module.css";

export default function FormClient() {
    const navigate = useNavigate();
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);

    // 인증 확인 및 자동 로그아웃 설정
    useEffect(() => {
        if (!apiService.isAuthenticated()) {
            navigate("/admin/login");
            return;
        }

        const cleanup = setupAutoLogout(() => {
            navigate("/admin/login");
        });

        apiService.setTokenExpiredCallback(() => {
            navigate("/admin/login");
        });

        return cleanup;
    }, [navigate]);

    useEffect(() => {
        const fetchItem = async () => {
            try {
                // 조직도는 항상 하나만 있으므로 id와 관계없이 가져옴
                const data = await apiService.getOrganization();
                setItem(data);
            } catch (error) {
                console.error("Failed to fetch organization:", error);
                // 에러 발생 시에도 빈 객체로 설정하여 새로 생성 가능하도록
                setItem(null);
            } finally {
                setLoading(false);
            }
        };

        fetchItem();
    }, []);

    const handleSubmit = () => {
        navigate("/admin/notices?tab=organization");
    };

    const handleCancel = () => {
        navigate("/admin/notices?tab=organization");
    };

    if (loading) {
        return (
            <div className={styles.noticeWrap}>
                <div className={styles.SubPageWidth}>
                    <div className={styles.header}>
                        <h1>조직도 이미지 수정</h1>
                        <button onClick={handleCancel} className={styles.backBtn}>
                            목록으로
                        </button>
                    </div>
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        데이터를 불러오는 중...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.noticeWrap}>
            <div className={styles.SubPageWidth}>
                <div className={styles.header}>
                    <h1>조직도 이미지 수정</h1>
                    <button onClick={handleCancel} className={styles.backBtn}>
                        목록으로
                    </button>
                </div>
                <OrganizationForm 
                    item={item} 
                    onSubmit={handleSubmit} 
                    onCancel={handleCancel} 
                />
            </div>
        </div>
    );
}

